import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

type Props = {
  error: string;
};

export default function InlineError(props: Props) {
  return (
    <div className="flex flex-row justify-end gap-2 pt-1 text-sm text-red-700">
      <div className="pointer-events-none flex items-center">
        <ExclamationCircleIcon
          className="h-5 w-5 text-red-700"
          aria-hidden="true"
        />
      </div>
      {props.error}
    </div>
  );
}
